<template>
  <div>
    <label>{{ data.label }}</label>
    <v-radio-group v-model="data.value">
      <v-radio
        v-for="option in data.options"
        :key="option.key"
        :label="option.label"
        :value="option.value"
      ></v-radio>
    </v-radio-group>
  </div>
</template>
<script>
export default {
  name: "NinjaFormsListCheckbox",
  props: {
    data: { type: Object }
  },
  data() {
    return {
      radioGroup: null
    };
  }
};
</script>
